import { useSearchParams, useNavigate } from 'react-router-dom';
import styles from './TestModalAuthFlow.module.css';
import triggerTopPageAuthenticationFlowConfig from '../utils/triggerTopPageAuthenticationFlow.config.json';

function TestModalAuthFlow() {
  const [searchParams] = useSearchParams();
  const { trigger: triggerParam } = Object.fromEntries(searchParams);
  const navigate = useNavigate();

  const triggers = Object.values(triggerTopPageAuthenticationFlowConfig)
    .map((config) => {
      return Object.values(config).map(({ trigger }) => trigger);
    })
    .flat();

  const shouldRenderModal = triggers.some(
    (trigger) => trigger === triggerParam,
  );

  if (!shouldRenderModal) {
    return null;
  }

  return (
    <div
      onClick={() => navigate(window.location.pathname)}
      className={styles.TestModalAuthFlow}
    >
      <dialog className={styles.dialog} open>
        <h1>Test Modal Auth Flow</h1>
        <p>{triggerParam}</p>
      </dialog>
    </div>
  );
}

export default TestModalAuthFlow;
